// Vendor imports
const classNames = require('classnames')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V2 common imports
const LazyImage = require('client-v2/common/components/lazy-image')
const useLineClampFitStyle = require('client-v2/common/hooks/line-clamp')
const tag = require('client-v2/common/utils/hyperscript')

const bem = BemEntity('ShareModalArticlePreview')

function ShareModalArticlePreview({
  // Values
  article,
  className
}) {
  return (
    tag('div', {
      className: classNames(
        className,
        bem.block()
      )
    },
      tag(ShareModalArticlePreviewContent, {
        article
      })
    )
  )
}

if (__DEV__) {
  // Prop-checking imports
  const PropTypes = require('prop-types')
  const ArticleModelRecord = require('client-v2/common/models/article/record')

  ShareModalArticlePreview.propTypes = {
    // Values
    article: PropTypes.shape(ArticleModelRecord.propTypes),
    className: PropTypes.string
  }
}

module.exports = ShareModalArticlePreview

function ShareModalArticlePreviewContent({
  article
}) {
  const titleRef = React.useRef()
  const titleStyle = useLineClampFitStyle({
    disabled: !article,
    domRef: titleRef
  })
  const descriptionRef = React.useRef()
  const descriptionStyle = useLineClampFitStyle({
    disabled: !article,
    domRef: descriptionRef
  })
  if (!article) {
    return null
  }
  return (
    tag('div', {
      className: bem.element('content')
    },
      tag(LazyImage, {
        className: bem.element('image'),
        sources: [ article.md5image, article.image ]
      }),
      tag('div', {
        className: bem.element('details')
      },
        tag('div', {
          className: bem.element('domain')
        },
          article.hostname
        ),
        tag('div', {
          ref: titleRef,
          className: bem.element('title'),
          style: titleStyle
        },
          article.title
        ),
        tag('div', {
          ref: descriptionRef,
          className: bem.element('description'),
          style: descriptionStyle
        },
          article.description
        )
      )
    )
  )
}
